'use strict';

/** @type {import('.')} */
var $gOPD = require('./gOPD');

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;



//////////////////
// WEBPACK FOOTER
// ./~/_gopd@1.2.0@gopd/index.js
// module id = hgaQ
// module chunks = 0